"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
function Select(_a) {
    var options = _a.options, onChange = _a.onChange;
    var selectId = react_1.default.useId();
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)("select", { onChange: function (e) { return onChange === null || onChange === void 0 ? void 0 : onChange(parseInt(e.target.value)); }, children: options.map(function (label, index) { return ((0, jsx_runtime_1.jsx)("option", { value: index, children: label }, "".concat(selectId, "-").concat(index))); }) }) }));
}
exports.default = Select;
